import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from "react-router-dom";

import InvoiceDetailsView from '../../../external/invoice/invoice/invoice-form/invoice-form-view.container';
import { invoiceInvoiceActions } from "../../../../store/external/invoice/invoice.reducer";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { invoiceDetailsAction } from "../../../../store/external/invoice/invoice/invoice-details.reducer";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils"
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import { ROUTE_LINK_LOCATION } from "../../../../constants/external-constants";


class LinkedInvoiceDetailsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoaded: true,
            selectedInvoice: undefined
        };
    }


    async componentDidMount() {
        const { getLinkedInvoiceDetails, getInvoiceDetailsForm } = this.props;
        const { linkedInvoiceID } = this.props.match.params;

        const data = await getLinkedInvoiceDetails(linkedInvoiceID);
        await getInvoiceDetailsForm(linkedInvoiceID, data.BillingAccountNumber.AccountNumber);

        this.setState({
            selectedInvoice: data,
            isLoaded: true
        });
    }


    handleCloseForm = () => {
        this.props.history.push(ROUTE_LINK_LOCATION.invoiceDashboard);
    }

    render() {
        const { linkedInvoiceID } = this.props.match.params;
        const { isLoaded, selectedInvoice } = this.state;

        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceInvoiceDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceInvoiceDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceInvoiceDashboardRW])

        const roles = {
            isReadOnly,
            isReadAndWrite,
            isReadAndExtractOnly
        }


        return (
            <>
                {
                    isLoaded ?
                    <div className="invoice-wrapper-container inventory-report-component" >
                        <RequestHeaders headerTitle="invoice_details_view" />
                        <div className="request-table data-table fit-width">

                            <InvoiceDetailsView
                                handleClose={this.handleCloseForm.bind(this)}
                                invoiceId={linkedInvoiceID}
                                selectedInvoice={selectedInvoice}
                                roles={roles}
                            >


                            </InvoiceDetailsView>

                        </div>
                    </div>
                    : <NoSubscription />
                }
            </>
         );  
    }
}


function LinkedInvoiceDetails(props) {
    const history = useHistory();
    return <LinkedInvoiceDetailsComponent {...props} history={history} />
}

export default connect(
    state => {
        const { invoiceInvoice } = state;
        return {
            invoiceInvoice
        }
    },
    dispatch => bindActionCreators(
        Object.assign({}
            , invoiceInvoiceActions
            , invoiceDetailsAction),
        dispatch)
)(LinkedInvoiceDetails)